import React from 'react';
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
function Placeholder(props) {
   const {selectProps, innerProps = {}, children} = props;
   return (
      <Typography
         variant="body1"
         color="textSecondary"
         className={selectProps.classes.placeholder}
         {...innerProps}
      >
         {children}
      </Typography>
   );
}

Placeholder.propTypes = {
   /**
    * The children to be rendered.
    */
   children: PropTypes.node,
   /**
    * props passed to the wrapping element for the group.
    */
   innerProps: PropTypes.object,
   selectProps: PropTypes.object.isRequired
};

export default Placeholder;
